export default __webpack_public_path__ + "static/media/ic_fxs_40.0f96619d.svg";